import { useEffect } from 'react';

import { loadFingerprint } from '../helpers/fingerprint';
import resources from '../helpers/resources';

const client = resources();

export function useFingerprint() {
  useEffect(() => {
    (async () => {
      const fingerprint = await loadFingerprint();
      try {
        await client.uploadFingerprint(fingerprint);
      } catch (error) {
        console.error('fingerprint error', error);
      }
    })();
  }, []);
}
